import { ProgressIndicator } from '@oneaudi/unified-web-components';
import { SliderItemsProps } from '~/components/slider-panel/components/slider-items/models/slider-items-props';
import {
	SliderItemsLoaderStyle,
	SliderItemsStyle,
} from '~/components/slider-panel/components/slider-items/styles/slider-items-style';

export function SliderItems({
	children,
	isSliderExpanded,
	isSliderBlocked,
	loaderOnIndex,
	sliderItemWidth,
}: SliderItemsProps) {
	return (
		<>
			{children.map((child, index) => (
				<SliderItemsStyle
					key={index}
					sliderItemWidth={sliderItemWidth}
					className={`slider-stage__canvas-item ${isSliderExpanded && 'expanded'} ${
						(loaderOnIndex === index || isSliderBlocked) && 'is-loading'
					}`}>
					{child}
					{loaderOnIndex === index && (
						<SliderItemsLoaderStyle>
							<ProgressIndicator variant={'spinner'} type={'infinite'} />
						</SliderItemsLoaderStyle>
					)}
				</SliderItemsStyle>
			))}
		</>
	);
}
